<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaFaturas(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">FATURAS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom v-if="user.tipo == 'ADMIN' && !item.cobrancaCriada">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="gerarCobranca(item)" color="#01579B">mdi-cash-sync</v-icon>
                </v-btn>
              </template>
              <span>Gerar cobrança</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="detalhesFatura(item)" color="#01579B">mdi-barcode</v-icon>
                </v-btn>
              </template>
              <span>Detalhes</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.valorConsumos`]="{ item }">
            <td>{{ retornaValorFormatado(item.valorConsumos) }}</td>
          </template>
          <template v-slot:[`item.porcentagem`]="{ item }">
            {{ item.porcentagem }}%
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            {{ retornaValorFormatado(item.valor) }}
          </template>
          <template v-slot:[`item.dataFim`]="{ item }">
            <td>{{ retornaPeriodoFatura(item) }}</td>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <td v-if="item.cobrancaCriada">{{ formatDate(item.boleto.dataEmissao.split('T')[0])}}</td>
            <td v-else style="color: #bbb">N/A</td>
          </template>
          <template v-slot:[`item.vencimento`]="{ item }">
            <td v-if="item.cobrancaCriada">{{ formatDate(item.vencimento) }}</td>
            <td v-else style="color: #bbb">N/A</td>
          </template>
          <template v-slot:[`item.statusPagamento`]="{ item }">
            <v-chip v-if="item.statusPagamento" dark label :color="getIconOrColor(item.statusPagamento).color">
              <v-icon left>{{ getIconOrColor(item.statusPagamento).icon }}</v-icon>
              {{ item.statusPagamento }}
            </v-chip>
            <td v-else style="color: #bbb">N/A</td>
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert dark dense text outlined color="warning" icon="info" style="margin: 10px">Nenhuma fatura localizada</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogCartoes" max-width="600" persistent scrollable>
      <v-card>
        <v-card-title>Detalhes da fatura</v-card-title>
        <v-card-subtitle class="pb-3">
          Período:
          {{ formatDate(editedItem.dataInicio) }} a {{ formatDate(editedItem.dataFim) }}
        </v-card-subtitle>

        <v-divider />

        <v-card-text class="pt-3">
          <v-row>
            <v-col cols="12" sm="6">
              <strong>Quantidade de consumos</strong><br>
              {{ editedItem.quantidadeTotalTransacoes }}
            </v-col>

            <v-col cols="12" sm="6">
              <strong>Valor total dos consumos</strong><br>
              {{ retornaValorFormatado(editedItem.valorConsumos) }}
            </v-col>

            <v-col cols="12" sm="6">
              <strong>Taxa aplicada ({{ editedItem.porcentagem }}%)</strong><br>
              {{ retornaValorFormatado(editedItem.valor) }}
            </v-col>

            <v-col cols="12" sm="6">
              <strong>Status</strong><br>
              <v-chip
                dark
                small
                :color="getIconOrColor(editedItem.statusPagamento).color"

              >
                {{ editedItem.statusPagamento || 'Não emitido' }}
              </v-chip>
            </v-col>
          </v-row>

          <v-alert type="info" class="mt-4">
            <strong>Valor da fatura: {{ retornaValorFormatado(editedItem.valor) }}<br></strong> 
            <strong v-if="editedItem.vencimento">Vencimento: {{ formatDate(editedItem.vencimento) }}</strong>
          </v-alert>

          <v-divider v-if="editedItem.statusPagamento == 'PENDENTE'" class="my-4" />

          <v-row dense v-if="editedItem.statusPagamento == 'PENDENTE'">
            <v-col cols="12">
              <h3 class="mb-2">Pagamento via boleto</h3>
            </v-col>

            <v-col cols="12">
              <div class="barcode-wrapper">
                <svg ref="barcode"></svg>
              </div>
            </v-col>

            <v-col cols="12">
              <v-text-field
                label="Linha digitável"
                :value="editedItem.boleto.linhaDigitavel"
                readonly
                @click:append="copiarTexto(editedItem.boleto.linhaDigitavel)"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-btn color="primary" block depressed v-if="editedItem.boleto.pdfBoleto" @click="abrirPdfBase64(editedItem.boleto.pdfBoleto)">
                <v-icon left>mdi-printer</v-icon>
                Imprimir boleto
              </v-btn>

              <v-btn color="primary" block depressed v-else @click="abrirPdfUrl(editedItem.boleto.url)">
                <v-icon left>mdi-printer</v-icon>
                Imprimir boleto
              </v-btn>
            </v-col>

            <v-col cols="12" sm="6">
              <v-btn color="primary" block depressed @click="copiarTexto(editedItem.boleto.linhaDigitavel)" :disabled="textoCopiado">
                <v-icon left>{{ textoCopiado ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
                {{ textoCopiado ? 'Código copiado!' : 'Copiar código' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" text @click="dialogCartoes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import JsBarcode from 'jsbarcode';

  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      lojistas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Valor de Consumos', align: 'start', value: 'valorConsumos', },
          { text: 'Porcentagem', value: 'porcentagem', },
          { text: 'Valor da Fatura', value: 'valor' },
          { text: 'Consumos contabilizados', value: 'quantidadeTotalTransacoes' },
          { text: 'Período', value: 'dataFim' },
          { text: 'Emissão', value: 'created' },
          { text: 'Vencimento', value: 'vencimento' },
          { text: 'Status', value: 'statusPagamento' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogCartoes: false,
      editedIndex: -1,
      editedItem: {
        valorConsumos: '',
        porcentagem: '',
        valor: '',
        quantidadeTotalTransacoes: '',
        statusPagamento: '',
        vencimento: '',
        cobrancaCriada: true,
        dataInicio: '',
        dataFim: '',
        boleto: {
          codigoBarras: '',
          linhaDigitavel: '',
          url: '',
          dataEmissao: '',
        },
        pagamentoId: '',
      },
      defaultItem: {
        valorConsumos: '',
        porcentagem: '',
        valor: '',
        quantidadeTotalTransacoes: '',
        statusPagamento: '',
        vencimento: '',
        cobrancaCriada: true,
        dataInicio: '',
        dataFim: '',
        boleto: {
          codigoBarras: '',
          linhaDigitavel: '',
          url: '',
          dataEmissao: '',
        },
        pagamentoId: '',
      },
      empresas: [],
      empresaSelecionada: '',
      lojistaSelecionado: '',
      textoCopiado: false,
    }),

    computed: mapState({
      ConsumidorLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo usuário' : 'Detalhes do Cartão'
      },
    }),

    watch: {
      dialogCartoes(val) {
        if (val == false) {
          setTimeout(() => {
            if (this.editedItem.statusPagamento != 'PAGO') {
              const el = this.$refs.barcode;
              el.innerHTML = '';
            }
            
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaFaturas()
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      formatDate(date) {
        let data = date.split('T')[0]
        const [ano, mes, dia] = data.split('-')
        return dia + '/' + mes + '/' + ano
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async carregaFaturas(empresaId) {
        let url = ''
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true


        if (empresaId) {
          url = baseApiUrl + 'Faturas?filter={"where":{"empresaId":"' + empresaId + '"}, "order": "created DESC"}&access_token=' + sessionStorage.getItem('accToken')
        } else {
          url = baseApiUrl + 'Faturas?filter={"where":{"empresaId":"' + this.user.empresaId + '"}, "order": "created DESC"}&access_token=' + sessionStorage.getItem('accToken')
        }

        await axios.get(url)
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      detalhesFatura(item) {
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogCartoes = true

        setTimeout(() => {
          if (item.statusPagamento != 'PAGO') {
            let isMobile = this.$vuetify.breakpoint.xs;
  
            JsBarcode(this.$refs.barcode, item.boleto.codigoBarras, {
              format: 'ITF',
              width: isMobile ? 1 : 1.9,
              height: isMobile ? 70 : 80,
              displayValue: false
            });
          }
        }, 100);
      },

      retornaValorFormatado(valor) {
        return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      getIconOrColor(status) {
        let iconStatus = {
          PAGO: {
            icon: 'mdi-check-circle',
            color: 'green'
          },
          ISENTO: {
            icon: 'mdi-check-circle',
            color: 'green'
          },
          PENDENTE: {
            icon: 'mdi-alert-circle',
            color: 'orange'
          },
        }

        return iconStatus[status] || { icon: 'mdi-alert-circle', color: 'blue' }
      },

      async gerarCobranca(item) {
        let resposta = confirm('A ação fará com que a cobrança para a fatura seja gerada. Deseja continuar?')

        if (resposta) {
          let vm = this
          this.isLoading = true

          await axios.post(baseApiUrl + 'ServiceIntelitePay/criarCobranca', {'faturaId': item.id})
          .then(response => {
            if (response.data) {
              this.carregaFaturas(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.user.empresaId);
              vm.$refs.chamaSnackbar.snack("green", "Fatura emitida!", "SUCESSO");
            }
          })
          .catch(error => {
            vm.$refs.chamaSnackbar.snack("red", "Problema ao emitir cobrança. " + error.response.data.error.error || '', "DESCULPE");
          })

          this.isLoading = false
        }
      },

      copiarTexto(texto) {
        navigator.clipboard.writeText(texto)
        this.textoCopiado = true

        setTimeout(() => {
          this.textoCopiado = false
        }, 3000);
      },

      abrirPdfBase64(base64) {
        let byteCharacters = atob(base64);
        let byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: 'application/pdf' });

        let blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      },

      abrirPdfUrl(url) {
        window.open(url, '_blank');
      },

      retornaPeriodoFatura(fatura) {
        let data = fatura.dataInicio.split('T')[0]

        return data.split('-')[2] + ' a ' + this.formatDate(fatura.dataFim)
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }

  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }

  .barcode-wrapper {
    width: 100%;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
  }
</style>
